import { render } from "./payDialog.vue?vue&type=template&id=3bb1dac5&scoped=true"
import script from "./payDialog.vue?vue&type=script&lang=js"
export * from "./payDialog.vue?vue&type=script&lang=js"

import "./payDialog.vue?vue&type=style&index=0&id=3bb1dac5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb1dac5"]])

export default __exports__